<!--<div class="tm-header-placeholder uk-margin-remove-adjacent" style="height: 84px;"></div>-->
<div class="uk-section uk-section-xsmall">
  <div class="uk-container uk-container-expand">
    @if (breadcrumbs) {
      <div>
        @if (goBack) {
          <a class="goBackLink" [routerLink]="['/search']">
            <img src="../../assets/images/icons/ic_back_arrow_link.svg" class="uk-margin-small-right">Go Back to Services
          </a>
        }
        @if (!goBack) {
          <ul class="uk-breadcrumb">
            @for (breadcrumb of breadcrumbs; track breadcrumb.url; let isLast = $last; let i = $index) {
              <li>
                @if (!isLast && breadcrumb.navigable) {
                  <a [href]="breadcrumb.url">{{breadcrumb.label}}</a>
                }
                @if (!isLast && !breadcrumb.navigable) {
                  <span>{{breadcrumb.label}}</span>
                }
                @if (isLast) {
                  <span>{{breadcrumb.label}}</span>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>
</div>

